import { render, staticRenderFns } from "./NtagTagRow.vue?vue&type=template&id=57919a0b&scoped=true&"
import script from "./NtagTagRow.vue?vue&type=script&lang=ts&"
export * from "./NtagTagRow.vue?vue&type=script&lang=ts&"
import style0 from "./NtagTagRow.vue?vue&type=style&index=0&id=57919a0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57919a0b",
  null
  
)

export default component.exports